"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_CARDS_ORIENTATIONS = void 0;
var VIDEO_CARDS_ORIENTATIONS;
(function (VIDEO_CARDS_ORIENTATIONS) {
    VIDEO_CARDS_ORIENTATIONS[VIDEO_CARDS_ORIENTATIONS["VERTICAL"] = 1] = "VERTICAL";
    VIDEO_CARDS_ORIENTATIONS[VIDEO_CARDS_ORIENTATIONS["HORIZONTAL"] = 2] = "HORIZONTAL";
})(VIDEO_CARDS_ORIENTATIONS = exports.VIDEO_CARDS_ORIENTATIONS || (exports.VIDEO_CARDS_ORIENTATIONS = {}));
//# sourceMappingURL=orientations.js.map